<template>
    <div class="card shadow-sm bg-white">
        <div class="card-header h6">
            Rapport véhicule
        </div>
        <div class="card-body">
            <button type="button" class="btn btn-sm btn-outline-secondary mb-2" @click="toggleReportForm"
                :disabled="!baliseId || isLoading">
                <i class="fa-regular fa-file-pdf me-1"></i>
                Générer un rapport
            </button>

            <div v-if="!baliseId" class="small text-muted mt-1">
                Aucun véhicule sélectionné.
            </div>

            <div v-else-if="showReportForm" class="small mt-2">
                <div class="mb-2">
                    <label class="form-label mb-1">Du</label>
                    <input type="datetime-local" class="form-control form-control-sm" v-model="reportFrom">
                </div>
                <div class="mb-2">
                    <label class="form-label mb-1">Au</label>
                    <input type="datetime-local" class="form-control form-control-sm" v-model="reportTo">
                </div>
                <div class="d-flex justify-content-end gap-2 mt-1">
                    <button type="button" class="btn btn-sm btn-link text-secondary" @click="showReportForm = false"
                        :disabled="isLoading">
                        Annuler
                    </button>
                    <button type="button" class="btn btn-sm btn-primary" @click="onConfirmVehicleReport"
                        :disabled="isLoading">
                        <span v-if="!isLoading">Télécharger</span>
                        <span v-else>
                            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                            Génération...
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ReportService from '@/services/report.service.js'

export default {
    name: 'VehicleReportCard',
    props: {
        baliseId: {
            type: [Number, String],
            required: true
        }
    },
    data() {
        return {
            showReportForm: false,
            reportFrom: '',
            reportTo: '',
            isLoading: false
        }
    },
    methods: {
        toggleReportForm() {
            if (!this.baliseId) return;

            if (!this.showReportForm) {
                // Pré-remplit sur la semaine passée flottante (en local pour datetime-local)
                const to = new Date();
                const from = new Date();
                from.setDate(to.getDate() - 7);

                const toLocal = new Date(to.getTime() - to.getTimezoneOffset() * 60000);
                const fromLocal = new Date(from.getTime() - from.getTimezoneOffset() * 60000);

                this.reportTo = toLocal.toISOString().slice(0, 16);   // "YYYY-MM-DDTHH:MM"
                this.reportFrom = fromLocal.toISOString().slice(0, 16);
            }

            this.showReportForm = !this.showReportForm;
        },

        async onConfirmVehicleReport() {
            if (!this.reportFrom || !this.reportTo || !this.baliseId) {
                return;
            }

            const fromIso = new Date(this.reportFrom).toISOString();
            const toIso = new Date(this.reportTo).toISOString();

            let downloadUrl = null;
            try {
                this.isLoading = true;

                const resp = await ReportService.getVehicleReport(this.baliseId, fromIso, toIso);
                downloadUrl = (resp.data || {}).downloadUrl;
                if (!downloadUrl) {
                    throw new Error('downloadUrl manquant');
                }

                // Construit l’URL absolue vers /downloads
                const apiBase = process.env.VUE_APP_API_URL; // ex: https://srv.../api/
                const origin = new URL(apiBase).origin;      // -> https://srv...
                const absolute = new URL(downloadUrl, origin).toString();

                // Récupère le PDF en blob (CORS simple, pas de credentials)
                const fileResponse = await fetch(absolute, { mode: 'cors' });
                if (!fileResponse.ok) {
                    throw new Error(`Erreur HTTP ${fileResponse.status}`);
                }

                const blob = await fileResponse.blob();

                // Tente de récupérer un nom de fichier depuis Content-Disposition
                const cd =
                    fileResponse.headers.get('Content-Disposition') ||
                    fileResponse.headers.get('content-disposition');
                let filename = 'rapport-vehicule.pdf';
                if (cd) {
                    const match = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(cd);
                    if (match && match[1]) {
                        filename = match[1].replace(/['"]/g, '');
                    }
                } else {
                    const fromDateStr = fromIso.slice(0, 10);
                    const toDateStr = toIso.slice(0, 10);
                    filename = `rapport-vehicule-${this.baliseId}-${fromDateStr}_${toDateStr}.pdf`;
                }

                // Création d’un lien de téléchargement "virtuel"
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            } catch (e) {
                console.error('Erreur lors du téléchargement du rapport véhicule :', e);
                // Fallback : si quelque chose foire (CORS, autre), on revient au comportement "ouvrir l'URL"
                try {
                    const apiBase = process.env.VUE_APP_API_URL;
                    const origin = new URL(apiBase).origin;
                    const absolute = downloadUrl
                        ? new URL(downloadUrl, origin).toString()
                        : ''; if (absolute) {
                            window.open(absolute, '_blank', 'noopener');
                        }
                } catch (_) {
                    // on ne fait rien de plus, on a déjà loggé l’erreur
                }
            } finally {
                this.isLoading = false;
                this.showReportForm = false;
            }
        }
    }
}
</script>

<style scoped>
/* Pas de style spécifique pour l’instant : on s’appuie sur Bootstrap */
</style>
